﻿
export class Search {

    constructor() {

        let me = this;

        me.tokenUi = $(document.getElementById('divsearchbar'));

        me.getTokens = function () {

            let tokens = [];
            $.map(me.tokenUi.find(`.TokensContainer li.Token`), function (item) {
                tokens.push({ Value: $(item).attr('data-value'), Text: $(item).attr('data-text'), Category: $(item).attr('data-category') });
            });

            return $.unique(tokens);
        };

        me.getShortcuts = function (shortcut_val, shortcut_tex, shortcut_cat) {

            let shortcuts = [];
            shortcuts.push({ Value: shortcut_val, Text: shortcut_tex, Category: shortcut_cat });

            return $.unique(shortcuts);
        };

        me.getSearches = function (searches_val) {

            let searches = [];
            //shortcuts.push({ Value: shortcut_val, Text: shortcut_tex, Category: shortcut_cat });

            //return $.unique(shortcuts);

            //console.log(searches.join('| '));

            $.each(searches_val.split('| '), function (x, el) {
                searches.push({ Value: el.split('~')[0], Text: el.split('~')[1], Category: el.split('~')[2] });
            });

            return searches;
        };
    }
}

export var _shared_xfunc = {

    Tokens: [],

    tokenize_autocomplete: function () {

        let me = this;
        me.sport_label = $('#login-topiccode').val();

        $('#tokenize').tokenize({
            datas: "select",
            categoryField: "Category",
            valueField: "PhraseId",
            textField: "Phrase",
            searchParam: "Search",
            searchMinLength: 2,
            placeholder: "...",
            debounce: 0,
            sortable: false,
            nbDropdownElements: 15,
            onAddToken: function (value, text, category, e) {
                //_shared_xfunc.Tokens.push({ Value: value, Text: text, Category: category }); console.log($.unique(_shared_xfunc.Tokens).join('| '));

                var page = $('#hdn-Page').val();
                var keypress = $('#hdn-Keypress').val();

                if (page == 'landing' && keypress == 13)
                    $('.btn-search > input[value="Search"]').trigger("click");

                var ui = $(document.getElementById(`filter-list`));

                if (text === 'undefined') {

                    $('#tokenize').data('tokenize').tokenRemoveValue('undefined', 'undefined');
                }
                else {
                    if (category === 'Shortcut') {

                        $("#hdnShortcut").val(text);

                        if (text == "Streaks") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="allstreaks"]`).addClass('active');
                        }
                        else if (text == "Matchup Notes") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="matchup"]`).addClass('active');
                        }
                        else if (text == "Matchup Contrast") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="matchup"]`).addClass('active');
                        }
                        else if (text == "Split Contrast") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="split"]`).addClass('active');
                        }
                        else if (text == "Timeframe Contrast") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="timeframe"]`).addClass('active');
                        }
                        else if (text == "Keys To Game") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="keystogame"]`).addClass('active');
                        }
                        else if (text == "KTG") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="keystogame"]`).addClass('active');
                        }
                        else if (text == "Betting") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="betting"]`).addClass('active');
                        }
                        else if (text == "Advanced") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="advanced"]`).addClass('active');
                        }
                        else if (text == "Streak Leaders") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="streakleaders"]`).addClass('active');
                        }
                        else if (text == "Highs") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Lows', 'Lows', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Lows"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            //$(".TokensContainer").find('li[data-value="XXXXXXXXXXXXX"]').remove();

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            //$('option[value="XXXXXXXXXXXXX"]', $('#tokenize')).removeAttr('selected').prop('selected', false);

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="best"]`).addClass('active');
                        }
                        else if (text == "Lows") {

                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streaks', 'Streaks', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Notes', 'Matchup Notes', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Matchup Contrast', 'Matchup Contrast', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Keys To Game', 'Keys To Game', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('KTG', 'KTG', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Streak Leaders', 'Streak Leaders', 'Shortcut');
                            //$('#tokenize').data('tokenize').tokenRemoveValue('Highs', 'Highs', 'Shortcut');

                            $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Split Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Timeframe Contrast"]').remove();
                            $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                            $(".TokensContainer").find('li[data-value="KTG"]').remove();
                            $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                            $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                            $(".TokensContainer").find('li[data-value="Highs"]').remove();
                            $(".TokensContainer").find('li[data-value="ShotTracker Notes"]').remove();
                            $(".TokensContainer").find('li[data-value="Advanced"]').remove();//05172024

                            $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Split Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Timeframe Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                            $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="ShotTracker Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                            $('option[value="Advanced"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//05172024

                            $('#dd-shortcuts .dropdown-item').removeClass('active');
                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="worst"]`).addClass('active');
                        }
                    }
                    else if (category === 'Checkbox') {
                        if (me.sport_label == "NFL" || me.sport_label == "NCAAF") {
                            // Helper function to check parent category and all its children
                            const checkCategoryWithChildren = (categoryText) => {
                                const $cb = $('.form-check-input').filter(`[category="StatParentCategory"][text="${categoryText}"]`);
                                if (!$cb.is(':checked')) {
                                    $cb.prop('checked', true);
                                    const parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input[category="StatCategory"][parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                    $(`.form-check-input[category="Stat"][parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                }
                            };

                            if (text == "Offense") {
                                checkCategoryWithChildren("Offense");
                            }
                            else if (text == "Defense") {
                                checkCategoryWithChildren("Defense");
                            }
                            else {
                                ui.find('.form-check-input')
                                    .filter(`[text="${value}"]`)
                                    .each((_, item) => {
                                        if (!$(item).is(':checked')) {
                                            $(item).prop('checked', true);
                                        }
                                    });
                            }
                        }
                        else {
                            if (text == "Hitter Notes" || text == "Pitcher Notes" || text == "Starting Pitcher Notes") {

                                switch (text) {
                                    case "Hitter Notes":
                                    case "Pitcher Notes":

                                        var $cb = $(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${text}"]`);
                                        if (!$cb.is(':checked')) {

                                            $cb.prop('checked', true);
                                            var subjectclass1 = $cb.attr("subjectclass1");

                                            $(`.form-check-input`).filter(`[subjectclass1-parent="${subjectclass1}"]`).prop('checked', true);
                                        }
                                        break;
                                    case "Starting Pitcher Notes":

                                        var $cb = $(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${text}"]`);
                                        if (!$cb.is(':checked')) {

                                            $cb.prop('checked', true);
                                            var subjectclass2 = $cb.attr("subjectclass2");

                                            $(`.form-check-input`).filter(`[subjectclass2-parent="${subjectclass2}"]`).prop('checked', true);
                                        }
                                        break;
                                }
                            }
                            else if (text == "ShotTracker Notes") {
                                $(".TokensContainer").find('li[data-value="Streaks"]').remove();
                                $(".TokensContainer").find('li[data-value="Matchup Notes"]').remove();
                                $(".TokensContainer").find('li[data-value="Matchup Contrast"]').remove();
                                $(".TokensContainer").find('li[data-value="Keys To Game"]').remove();
                                $(".TokensContainer").find('li[data-value="KTG"]').remove();
                                $(".TokensContainer").find('li[data-value="Betting"]').remove();//04052023
                                $(".TokensContainer").find('li[data-value="Streak Leaders"]').remove();
                                $(".TokensContainer").find('li[data-value="Highs"]').remove();
                                $(".TokensContainer").find('li[data-value="Lows"]').remove();

                                $('option[value="Streaks"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Matchup Notes"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Matchup Contrast"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Keys To Game"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="KTG"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Betting"]', $('#tokenize')).removeAttr('selected').prop('selected', false);//04052023
                                $('option[value="Streak Leaders"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Highs"]', $('#tokenize')).removeAttr('selected').prop('selected', false);
                                $('option[value="Lows"]', $('#tokenize')).removeAttr('selected').prop('selected', false);

                                $('#dd-shortcuts .dropdown-item').removeClass('active');
                                $('#dd-shortcuts .dropdown-item').filter(`[shortcut="shottracker"]`).addClass('active');
                            }
                            else if (text == "Offense Notes") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Offense"]`);
                                if (!$cb.is(':checked')) {

                                    $cb.prop('checked', true);
                                    var parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input`).filter(`[category="StatCategory"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                }
                            }
                            else if (text == "Defense Notes") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Defense"]`);
                                if (!$cb.is(':checked')) {

                                    $cb.prop('checked', true);
                                    var parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input`).filter(`[category="StatCategory"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', true);
                                }

                                var $cb2 = $(`.form-check-input`).filter(`[category="Category"]`).filter(`[text="Defense"]`);
                                if (!$cb2.is(':checked')) {

                                    $cb2.prop('checked', true);
                                    var categoryid = $cb2.attr("value");
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${categoryid}"]`).prop('checked', true);
                                }
                            }
                            else if (text == "Tendency Notes") {

                                var $cb_htn = $(`.form-check-input`).filter(`[text="High Tendency Notes"]`);
                                if (!$cb_htn.is(':checked')) {

                                    $cb_htn.prop('checked', true);
                                }

                                var $cb_ltn = $(`.form-check-input`).filter(`[text="Low Tendency Notes"]`);
                                if (!$cb_ltn.is(':checked')) {

                                    $cb_ltn.prop('checked', true);
                                }
                            }
                            else if (text == "Scoring Tendency") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Scoring Tendency"]`);
                                if (!$cb.is(':checked')) {

                                    $cb.prop('checked', true);
                                    var categoryid = $cb.attr("categoryid");
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${categoryid}"]`).prop('checked', true);
                                }
                            }
                            else {

                                $.map(ui.find(`.form-check-input`).filter(`[text="${value}"]`), function (item) {

                                    if (!$(item).is(':checked')) {

                                        $(item).prop('checked', true);
                                    }
                                });
                            }
                        }
                    }
                    else if (category === 'Team') {

                        $(`[data-id="flexCheck-${category}-${value}"]`).prop('checked', true);

                        $.map(ui.find(`.form-check-input`).filter(`[teamid="${value}"]`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);

                                $('#hdnSubjectId3').val(value);

                                $.ajax({
                                    url: "/Home/GetTeamSubjectClassId",
                                    dataType: "json",
                                    type: 'POST'
                                })
                                    .done(function (data) {
                                        $('#hdnSubjectClassId3').val(data);
                                    })
                                    .fail(function (textStatus, errorThrown) {

                                    });
                            }
                        });
                    }
                    else if (category === 'Player') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);

                                $('#hdnSubjectId3').val(value);

                                $.ajax({
                                    url: "/Home/GetPlayerSubjectClassId",
                                    dataType: "json",
                                    type: 'POST'
                                })
                                    .done(function (data) {
                                        $('#hdnSubjectClassId3').val(data);
                                    })
                                    .fail(function (textStatus, errorThrown) {

                                    });
                            }
                        });
                    }
                    else if (category === 'Timeframe') {

                        //$.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${value}"]`), function (item) {
                        //    $(item).prop('checked', true);
                        //});

                        $.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[value="${value}"]`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);
                            }
                        });
                    }
                    else if (category === 'Position') {
                        if (me.sport_label == "NFL" || me.sport_label == "NCAAF") {
                            // Helper function to check a checkbox by text
                            const checkBox = (boxText) => {
                                const $cb = $('.form-check-input').filter(`[category="Position"][text="${boxText}"]`);
                                if (!$cb.is(':checked')) {
                                    $cb.prop('checked', true);
                                }
                            };

                            if (text == "Team Offense") {
                                const offenseBoxes = [
                                    "NFL Offenses",
                                    "FBS Offenses"
                                ];
                                offenseBoxes.forEach(checkBox);
                            }
                            else if (text == "Team Defense") {
                                const defenseBoxes = [
                                    "NFL Defenses",
                                    "NFL Defenses against opposing RBs",
                                    "NFL Defenses against opposing TEs",
                                    "NFL Defenses against opposing WRs",
                                    "NFL Defensive Lines",
                                    "NFL Secondaries",
                                    "SEC East Defenses",
                                    "SEC West Defenses"
                                ];
                                defenseBoxes.forEach(checkBox);
                            }
                            else {
                                ui.find('.form-check-input')
                                    .filter(`[category="${category}"][value="${value}"]`)
                                    .each((_, item) => {
                                        if (!$(item).is(':checked')) {
                                            $(item).prop('checked', true);
                                        }
                                    });
                            }
                        }
                        else {
                            // Default for non-NFL sports
                            ui.find('.form-check-input')
                                .filter(`[category="${category}"][value="${value}"]`)
                                .each((_, item) => {
                                    if (!$(item).is(':checked')) {
                                        $(item).prop('checked', true);
                                    }
                                });
                        }
                    }
                    else if (category === 'StatCategory') {

                        var $triggeredStatCat = ui.find(`.form-check-input[category="${category}"][value="${value}"]:checked`).first();
                        var statCatMethod = $triggeredStatCat.length ? $triggeredStatCat.attr('method') : null;

                        if (statCatMethod) {
                            $.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[method="${statCatMethod}"]`).filter(`[value="${value}"]`), function (item) {
                                if (!$(item).is(':checked')) {
                                    $(item).prop('checked', true);
                                }
                            });
                            $.map(ui.find(`.form-check-input`).filter(`[category="Stat"]`).filter(`[method="${statCatMethod}"]`).filter(`[categoryid="${value}"]`), function (item) {
                                if (!$(item).is(':checked')) {
                                    $(item).prop('checked', true);
                                }
                            });
                        } else {
                            $.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[value="${value}"]`), function (item) {
                                if (!$(item).is(':checked')) {
                                    $(item).prop('checked', true);
                                }
                            });
                            $.map(ui.find(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${value}"]`), function (item) {
                                if (!$(item).is(':checked')) {
                                    $(item).prop('checked', true);
                                }
                            });
                        }
                    }
                    else if (category === 'Stat') {

                        var array = value.toString().split(",");

                        if (array.length === 1) {

                            $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                                if (!$(item).is(':checked')) {

                                    $(item).prop('checked', true);
                                }
                            });
                        }
                        else if (array.length > 1) {

                            $.each(array, function (i) {

                                $.map(ui.find(`[data-id="flexCheck-${category}-${array[i]}"]`), function (item) {

                                    if (!$(item).is(':checked')) {

                                        $(item).prop('checked', true);
                                    }
                                });
                            });
                        }
                    }
                    else if (category === 'Split') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                            if (!$(item).is(':checked')) {
                                $(item).prop('checked', true);
                            }
                        });
                    }
                    else if (category === 'Population') {

                        $.map(ui.find(`[id="flexCheck-${category}-${value}"]`), function (item) {

                            if (!$(item).is(':checked')) {
                                $(item).prop('checked', true);
                            }
                        });
                    }
                    else if (category === 'Conference') {

                        // "ACC" is the common short name for the Atlantic Coast conference, but the
                        // checkbox itself is keyed by the full name -- resolve the alias before matching.
                        var conferenceAliases = { 'ACC': 'Atlantic Coast' };
                        var conferenceText = conferenceAliases[text.toUpperCase()] || text;

                        $.map(ui.find(`[data-id="flexCheck-${category}-${conferenceText.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);
                            }
                        });

                        $.map(ui.find(`.form-check-input`).filter(`[conference="${conferenceText.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {
                            $(item).prop('checked', true);
                        });
                    }
                    else if (category === 'Division') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);
                            }
                        });

                        $.map(ui.find(`.form-check-input`).filter(`[division="${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {
                            $(item).prop('checked', true);
                        });
                    }
                    else {

                        $.map(ui.find(`#flexCheck-${category}-${value}`), function (item) {

                            if (!$(item).is(':checked')) {

                                $(item).prop('checked', true);
                            }
                        });

                        //me.notes.drawTable();
                    }
                    //me.notes.autocheckSimilarNotes();
                }

                _shared_xfunc.DoAjaxPost("/Home/UpdateSearchCounter", 2, { username: $('#login-username').val() });
            },
            onRemoveTokenValue: function (value, text, category, e, cb) {

                //_shared_xfunc.Tokens.pop({ Value: value, Text: text, Category: category }); console.log($.unique(_shared_xfunc.Tokens).join('| '));

                var ui = $(document.getElementById(`filter-list`));

                if (text === 'undefined') {

                    $('#tokenize').data('tokenize').tokenRemoveValue('undefined', 'undefined');
                }
                else {
                    if (category === 'Shortcut') {

                        $("#hdnShortcut").val("");

                        if (text == "Streaks") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="allstreaks"]`).removeClass('active');
                        }
                        else if (text == "Matchup Notes" || text == "Matchup Contrast") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="matchup"]`).removeClass('active');
                        }
                        else if (text == "Split Contrast") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="split"]`).removeClass('active');
                        }
                        else if (text == "Timeframe Contrast") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="timeframe"]`).removeClass('active');
                        }
                        else if (text == "KTG" || text == "Keys To Game") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="keystogame"]`).removeClass('active');
                        }
                        else if (text == "Betting") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="betting"]`).removeClass('active');
                        }
                        else if (text == "Streak Leaders") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="streakleaders"]`).removeClass('active');
                        }
                        else if (text == "Highs") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="best"]`).removeClass('active');
                        }
                        else if (text == "Lows") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="worst"]`).removeClass('active');
                        }
                        else if (text == "Advanced") {

                            $('#dd-shortcuts .dropdown-item').filter(`[shortcut="advanced"]`).removeClass('active');
                        }
                    }
                    else if (category === 'Checkbox') {
                        if (me.sport_label == "NFL" || me.sport_label == "NCAAF") {
                            // Helper function to uncheck parent category and all its children
                            const uncheckCategoryWithChildren = (categoryText) => {
                                const $cb = $('.form-check-input').filter(`[category="StatParentCategory"][text="${categoryText}"]`);
                                if ($cb.is(':checked')) {
                                    $cb.prop('checked', false);
                                    const parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input[category="StatCategory"][parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                    $(`.form-check-input[category="Stat"][parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                }
                            };

                            if (text == "Offense") {
                                uncheckCategoryWithChildren("Offense");
                            }
                            else if (text == "Defense") {
                                uncheckCategoryWithChildren("Defense");
                            }
                            else {
                                ui.find('.form-check-input')
                                    .filter(`[text="${value}"]`)
                                    .each((_, item) => {
                                        if ($(item).is(':checked')) {
                                            $(item).prop('checked', false);
                                        }
                                    });
                            }
                        }
                        else {
                            if (text == "Hitter Notes" || text == "Pitcher Notes" || text == "Starting Pitcher Notes") {

                                switch (text) {
                                    case "Hitter Notes":
                                    case "Pitcher Notes":

                                        var $cb = $(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${text}"]`);
                                        if ($cb.is(':checked')) {

                                            $cb.prop('checked', false);
                                            var subjectclass1 = $cb.attr("subjectclass1");

                                            $(`.form-check-input`).filter(`[subjectclass1-parent="${subjectclass1}"]`).prop('checked', false);
                                        }
                                        break;
                                    case "Starting Pitcher Notes":

                                        var $cb = $(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${text}"]`);
                                        if ($cb.is(':checked')) {

                                            $cb.prop('checked', false);
                                            var subjectclass2 = $cb.attr("subjectclass2");

                                            $(`.form-check-input`).filter(`[subjectclass2-parent="${subjectclass2}"]`).prop('checked', false);
                                        }
                                        break;
                                }
                            }
                            else if (text == "ShotTracker Notes") {
                                $('#dd-shortcuts .dropdown-item').filter(`[shortcut="shottracker"]`).removeClass('active');
                            }
                            else if (text == "Offense Notes") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Offense"]`);
                                if ($cb.is(':checked')) {

                                    $cb.prop('checked', false);
                                    var parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input`).filter(`[category="StatCategory"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                }
                            }
                            else if (text == "Defense Notes") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Defense"]`);
                                if ($cb.is(':checked')) {

                                    $cb.prop('checked', false);
                                    var parentcategoryid = $cb.attr("parentcategoryid");
                                    $(`.form-check-input`).filter(`[category="StatCategory"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[parentcategoryid="${parentcategoryid}"]`).prop('checked', false);
                                }

                                var $cb2 = $(`.form-check-input`).filter(`[category="Category"]`).filter(`[text="Defense"]`);
                                if (!$cb2.is(':checked')) {

                                    $cb2.prop('checked', false);
                                    var categoryid = $cb2.attr("value");
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${categoryid}"]`).prop('checked', false);
                                }
                            }
                            else if (text == "Tendency Notes") {

                                var $cb_htn = $(`.form-check-input`).filter(`[text="High Tendency Notes"]`);
                                if ($cb_htn.is(':checked')) {

                                    $cb_htn.prop('checked', false);
                                }

                                var $cb_ltn = $(`.form-check-input`).filter(`[text="Low Tendency Notes"]`);
                                if ($cb_ltn.is(':checked')) {

                                    $cb_ltn.prop('checked', false);
                                }
                            }
                            else if (text == "Scoring Tendency") {

                                var $cb = $(`.form-check-input`).filter(`[category="StatParentCategory"]`).filter(`[text="Scoring Tendency"]`);
                                if ($cb.is(':checked')) {

                                    $cb.prop('checked', false);
                                    var categoryid = $cb.attr("categoryid");
                                    $(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${categoryid}"]`).prop('checked', false);
                                }
                            }
                            else {

                                $.map(ui.find(`.form-check-input`).filter(`[text="${value}"]`), function (item) {

                                    if ($(item).is(':checked')) {

                                        $(item).prop('checked', false);
                                    }
                                });
                            }
                        }
                    }
                    else if (category === 'Team') {

                        $(`[data-id="flexCheck-${category}-${value}"]`).prop('checked', false);

                        $.map(ui.find(`.form-check-input`).filter(`[teamid="${value}"]`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);

                                $('#hdnSubjectId3').val('0');
                                $('#hdnSubjectClassId3').val('0');

                                var token = $(document.getElementById('divsearchbar'));
                                var players_len = token.find(`.TokensContainer li[data-category="Player"]`).length;
                                $.map(token.find(`.TokensContainer li[data-category="Player"]`), function (item) {
                                    $('#hdnSubjectId3').val($(item).attr('data-value'));
                                });

                                if (players_len > 0) {
                                    $.ajax({
                                        url: "/Home/GetPlayerSubjectClassId",
                                        dataType: "json",
                                        type: 'POST'
                                    })
                                        .done(function (data) {
                                            $('#hdnSubjectClassId3').val(data);
                                        })
                                        .fail(function (textStatus, errorThrown) {

                                        });
                                }
                            }
                        });
                    }
                    else if (category === 'Player') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);

                                $('#hdnSubjectId3').val('0');
                                $('#hdnSubjectClassId3').val('0');

                                var token = $(document.getElementById('divsearchbar'));
                                var teams_len = token.find(`.TokensContainer li[data-category="Team"]`).length;
                                $.map(token.find(`.TokensContainer li[data-category="Team"]`), function (item) {
                                    $('#hdnSubjectId3').val($(item).attr('data-value'));
                                });

                                if (teams_len > 0) {
                                    $.ajax({
                                        url: "/Home/GetTeamSubjectClassId",
                                        dataType: "json",
                                        type: 'POST'
                                    })
                                        .done(function (data) {
                                            $('#hdnSubjectClassId3').val(data);
                                        })
                                        .fail(function (textStatus, errorThrown) {

                                        });
                                }
                            }
                        });
                    }
                    else if (category === 'Timeframe') {

                        //$.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[text="${value}"]`), function (item) {
                        //    $(item).prop('checked', false);
                        //});

                        $.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[value="${value}"]`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);
                            }
                        });
                    }
                    else if (category === 'Position') {
                        if (me.sport_label == "NFL" || me.sport_label == "NCAAF") {
                            // Helper function to uncheck a checkbox by text
                            const uncheckBox = (boxText) => {
                                const $cb = $('.form-check-input').filter(`[category="Position"][text="${boxText}"]`);
                                if ($cb.is(':checked')) {
                                    $cb.prop('checked', false);
                                }
                            };

                            if (text == "Team Offense") {
                                const offenseBoxes = [
                                    "NFL Offenses",
                                    "FBS Offenses"
                                ];
                                offenseBoxes.forEach(uncheckBox);
                            }
                            else if (text == "Team Defense") {
                                const defenseBoxes = [
                                    "NFL Defenses",
                                    "NFL Defenses against opposing RBs",
                                    "NFL Defenses against opposing TEs",
                                    "NFL Defenses against opposing WRs",
                                    "NFL Defensive Lines",
                                    "NFL Secondaries",
                                    "SEC East Defenses",
                                    "SEC West Defenses"
                                ];
                                defenseBoxes.forEach(uncheckBox);
                            }
                            else {
                                ui.find('.form-check-input')
                                    .filter(`[category="${category}"][value="${value}"]`)
                                    .each((_, item) => {
                                        if ($(item).is(':checked')) {
                                            $(item).prop('checked', false);
                                        }
                                    });
                            }
                        }
                        else {
                            // Default for non-NFL sports
                            ui.find('.form-check-input')
                                .filter(`[category="${category}"][value="${value}"]`)
                                .each((_, item) => {
                                    if ($(item).is(':checked')) {
                                        $(item).prop('checked', false);
                                    }
                                });
                        }
                    }
                    else if (category === 'StatCategory') {

                        var statCatMethodRemove = window._statCategoryTokenRemoveMethod || null;

                        if (statCatMethodRemove) {
                            // Triggered by unchecking a filter checkbox — only uncheck that section's children.
                            // sidefilter.js already unchecked the header; the other section stays untouched.
                            $.map(ui.find(`.form-check-input`).filter(`[category="Stat"]`).filter(`[method="${statCatMethodRemove}"]`).filter(`[categoryid="${value}"]`), function (item) {
                                if ($(item).is(':checked')) {
                                    $(item).prop('checked', false);
                                }
                            });
                        } else {
                            // Triggered by removing the token from the search bar — uncheck all checked headers and children.
                            $.map(ui.find(`.form-check-input`).filter(`[category="${category}"]`).filter(`[value="${value}"]`), function (item) {
                                if ($(item).is(':checked')) {
                                    $(item).prop('checked', false);
                                }
                            });
                            $.map(ui.find(`.form-check-input`).filter(`[category="Stat"]`).filter(`[categoryid="${value}"]`), function (item) {
                                if ($(item).is(':checked')) {
                                    $(item).prop('checked', false);
                                }
                            });
                        }
                    }
                    else if (category === 'Stat') {

                        var array = value.toString().split(",");

                        if (array.length === 1) {

                            $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                                if ($(item).is(':checked')) {

                                    $(item).prop('checked', false);
                                }
                            });
                        }
                        else if (array.length > 1) {

                            $.each(array, function (i) {

                                $.map(ui.find(`[data-id="flexCheck-${category}-${array[i]}"]`), function (item) {

                                    if ($(item).is(':checked')) {

                                        $(item).prop('checked', false);
                                    }
                                });
                            });
                        }
                    }
                    else if (category === 'Split') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${value}"]`), function (item) {

                            if ($(item).is(':checked')) {
                                $(item).prop('checked', false);
                            }
                        });
                    }
                    else if (category === 'Population') {

                        $.map(ui.find(`[id="flexCheck-${category}-${value}"]`), function (item) {

                            if ($(item).is(':checked')) {
                                $(item).prop('checked', false);
                            }
                        });
                    }
                    else if (category === 'Conference') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);
                            }
                        });

                        $.map(ui.find(`.form-check-input`).filter(`[conference="${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {
                            $(item).prop('checked', false);
                        });
                    }
                    else if (category === 'Division') {

                        $.map(ui.find(`[data-id="flexCheck-${category}-${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);
                            }
                        });

                        $.map(ui.find(`.form-check-input`).filter(`[division="${text.replace(/[^A-Z0-9]/gi, '')}"]`), function (item) {
                            $(item).prop('checked', false);
                        });
                    }
                    else {

                        $.map(ui.find(`#flexCheck-${category}-${value}`), function (item) {

                            if ($(item).is(':checked')) {

                                $(item).prop('checked', false);
                            }
                        });

                        //me.notes.drawTable();
                    }
                    //me.notes.autouncheckSimilarNotes();
                }
            }
        });

    },

    getUnique: function (array) {

        var uniqueArray = [];

        // Loop through array values
        for (var value of array) {
            if (uniqueArray.indexOf(value) === -1) {
                uniqueArray.push(value);
            }
        }
        return uniqueArray;

    },

    spinner: function (show, elem) {

        if (show) {
            elem.parent().removeClass('d-none').addClass('d-block');
        }
        else {
            elem.parent().removeClass('d-block').addClass('d-none');
        }

    },

    DoAjaxPost: function (url, method, data, _cb, _err) {

        _shared_values.HTTP.url = url;
        _shared_values.HTTP.data = data;

        if (method == 1) {
            method = "get";
        }
        else if (method == 2) {
            method = "post";
        }
        _shared_values.HTTP.method = method;

        if (data == null || data == "")
            data = {};
        _shared_values.post_data = data;

        $.ajax({
            url: _shared_values.HTTP.url,
            type: _shared_values.HTTP.method,

            data: data,

            success: function (data) {

                if (_cb)
                    _cb(data);

            },

            error: function (jqXHR, exception) {

                if (_err) {
                    _err();
                }
            }

        });
    },

}

export var _shared_values = {

    HTTP: {
        url: null,
        method: null,
        data: null,
    },

}

export var helper = {

    Init: function (options) {
        $.ajaxSetup({ cache: false });

        // Ajax events fire in following order
        $(document).ajaxStart(function () {

        }).ajaxSend(function (e, xhr, opts) {
        }).ajaxError(function (e, xhr, opts) {

            if (options.SessionOut.StatusCode === xhr.status && document.location.href.indexOf('Account/Login') === -1 && helper.Alerted === 0) {
                helper.Alerted = 1;
                alert("You've been logged out!");

                document.location.replace(options.SessionOut.RedirectUrl);
                return;
            }

        }).ajaxSuccess(function (e, xhr, opts) {

        }).ajaxComplete(function (e, xhr, opts) {


        }).ajaxStop(function () {

        });
    },

    Alerted: 0,
}

String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
}

String.prototype.rtrim = function () {
    return this.replace(/((\s*\S+)*)\s*/, "$1");
}

jQuery.fn.extend({
    renameAttr: function (name, newName, removeData) {
        var val;
        return this.each(function () {
            val = jQuery.attr(this, name);
            jQuery.attr(this, newName, val);
            jQuery.removeAttr(this, name);
            // remove original data
            if (removeData !== false) {
                jQuery.removeData(this, name.replace('data-', ''));
            }
        });
    }
});